import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateVendorContact } from '../../../state/vendorSlice';

const PrimaryEmailEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentVendor } = useAppSelector(state => state.vendor);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateVendorContact({ primaryEmail: event.target.value }));
  };

  return (
    <TextField
      label="Email"
      size="small"
      fullWidth
      type="email"
      value={currentVendor?.primaryEmail || ''}
      onChange={handleChange}
    />
  );
};

export default PrimaryEmailEdit;
